import { Observable, map } from 'rxjs';
import type { z } from 'zod';

/**
 * RxJS operator that validates an HTTP response body against a Zod schema.
 *
 * Usage:
 * ```ts
 * this.http.get('/api/vendors')
 *   .pipe(validateResponse(VendorListSchema))
 *   .subscribe(vendors => ...);
 * ```
 *
 * Throws `Error('Invalid API response')` on schema mismatch so the
 * errorInterceptor normalises it into an ApiError.
 */
export function validateResponse<T extends z.ZodTypeAny>(
  schema: T,
): (source$: Observable<unknown>) => Observable<z.infer<T>> {
  return (source$) =>
    source$.pipe(
      map((raw) => {
        const parsed = schema.safeParse(raw);
        if (!parsed.success) {
           
          console.error('[VendorHub] API contract violation', parsed.error.issues);
          throw new Error('Invalid API response');
        }
        return parsed.data as z.infer<T>;
      }),
    );
}
